import {createSelector} from 'reselect';

const global = state => state.global;

export const selectGlobal = createSelector(
  global,
  globalSelect => globalSelect,
);
